import { Map } from 'immutable';
import { ADD_CACHE, PURGE_CACHE } from './constants';

export const initialState = Map({
	timeLimit: 300000,
});

const reducer = (state = initialState, action) => {
	// get this once rather than in each evaluation of cached items
	const cacheTimeLimit = state.get('timeLimit');
	switch (action.type) {
		case ADD_CACHE: {
			const newState = state.mergeIn(
				action.keyPath,
				Object.keys(action.values).reduce((acc, key) => {
					acc[key] = { ...action.values[key], timestamp: Date.now() };
					return acc;
				}, {}),
			);
			return newState;
		}
		case PURGE_CACHE:
			return state.updateIn(
				action.keyPath,
				cached =>
					cached && cached.filter(item => Date.now() - item.get('timestamp') < cacheTimeLimit),
			);
		default:
			return state;
	}
};

export default reducer;
